import type { AppNotification } from '@conference/shared';

export function selectHomeAnnouncements(
  notifications: AppNotification[],
  eventId: string,
  now: Date,
  limit: number,
): AppNotification[] {
  const nowMs = now.getTime();

  return notifications
    .filter((notification) => notification.event_id === eventId)
    .filter((notification) => {
      if (!notification.home_expires_at) return true;
      const expiryMs = Date.parse(notification.home_expires_at);
      return Number.isNaN(expiryMs) || expiryMs > nowMs;
    })
    .sort((left, right) => Date.parse(right.created_at) - Date.parse(left.created_at))
    .slice(0, Math.max(0, limit));
}
